module.exports = {"title":"Escolha um valor para sua recarga","currency":"R$"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/RechargePrices/data.json
// module id = 1847
// module chunks = 0